module.exports = __webpack_public_path__ + "img/79.2.TN.94435257.png";